import React from 'react';

const ManageUsers = () => {
  return (
    <div className="page-content">
      <h2>Manage Users</h2>
      <p>This is a dummy page for managing users.</p>
    </div>
  );
};

export default ManageUsers;
